import script from "./LazyBackgroundMedia.vue?vue&type=script&lang=ts&setup=true"
export * from "./LazyBackgroundMedia.vue?vue&type=script&lang=ts&setup=true"

import "./LazyBackgroundMedia.vue?vue&type=style&index=0&id=6e30fdb4&lang=scss"

const __exports__ = script;

export default __exports__